import axios from 'axios';

import ApiClient from '@lib/apiClient';

import { getCloudFrontUrl, getFileStorageUrl } from '@/constants/constant';

export const instance = axios.create({});

instance.interceptors.request.use((config) => {
	config.meta = config.meta || {};
	config.meta['request-startTime'] = Date.now();
	return config;
});

instance.interceptors.response.use((response) => {
	const start = response.config.meta['request-startTime'];
	const end = Date.now();
	response.responseTime = end - start;
	return response;
});

export const getApiResponseTime = async (urlDomain, urlSegment) => {
	const data = await instance.get(`${urlDomain}${urlSegment}`);
	return data.responseTime;
};

export const sendCloudFrontReport = async (isAlive) => {
	await ApiClient.POST('sendCloudFrontReport', '', `?isAlive=${isAlive}`);
};

export const checkApiResponseTime = async (filterResponse, fieldName = 'designDocuments') => {
	if (filterResponse?.data?.length > 0) {
		let lastElementDesignDocuments = filterResponse.data[filterResponse.data.length - 1][fieldName];
		let docUrl =
			fieldName === 'documentPathList'
				? lastElementDesignDocuments?.[0]
				: lastElementDesignDocuments?.[0]?.docUrl;

		if (docUrl) {
			let cloudFrontUrl = getCloudFrontUrl();
			let fileStorageUrl = getFileStorageUrl();

			let urlSegment = new URL(docUrl).pathname;

			let isAlive = true;
			let timeForCloudFront = await getApiResponseTime(cloudFrontUrl, urlSegment);

			if (timeForCloudFront > 2100) {
				let timeForFileStorage = await getApiResponseTime(fileStorageUrl, urlSegment);
				isAlive = timeForCloudFront < timeForFileStorage * 1.5;
			}

			await sendCloudFrontReport(isAlive);
		}
	}
};
